export default {
    customerList: [],
    customerData: {items: [], _links: {}, _meta: {}},
    customerHistory: [],
    customerHistoryData: {items: [], _links: {}, _meta: {}},
    customerInfo: {},
    groupData: {items: [], _links: {}, _meta: {}},
    groupList: [],

    groupMember: [],
    groupInfo: {items: [], _links: {}, _meta: {}},

    deleteGroupMember: [],
    deleteGroupInfo: {items: [], _links: {}, _meta: {}},

    chartInfo: {},

    customerListNotInGroup: [],

    customerGroup: [],

    customerCallingInfo: {},
    smsCallTemplate: []
}
